import '../App.css'
import { SearchInput } from '../components/ChatInput'
import { useChat } from '../context/ChatContext'
import { useNavigate } from 'react-router-dom'

function Home() {
  const { sendMessage, resetChat } = useChat();
  const navigate = useNavigate();

  const handleSubmit = async (value: string) => {
    resetChat();
    navigate('/chat');
    sendMessage(value, true);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6" style={{
      backgroundColor: 'var(--color-background)'
    }}>
      <div className="w-full max-w-xl mx-auto flex flex-col items-center justify-center">
        <h1 className="text-4xl font-bold text-center mb-8" style={{
          fontFamily: 'var(--font-heading)',
        }}>Hur kan jag hjälpa till?</h1>
        <SearchInput 
          placeholder="Vad letar du efter?" 
          selectedOptions={[]}
          onRemoveOption={() => {}}
          onSubmit={(text) => handleSubmit(text)}
        />
        <p className="text-center text-sm mt-8" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-tertiary)',
        }}>
          Skriv in vad du letar efter så hittar vi det tillsammans.
        </p>
      </div>
    </div>
  )
}

export default Home 